import { useQuery } from '@tanstack/react-query';
import PromptService from '../../../services/prompt-service';
import type { PromptData, StandardResponse } from '../../../types/agent';

const useGetPrompts = (options?: { enabled?: boolean }) => {
  return useQuery<StandardResponse<PromptData>>({
    queryKey: ['agents'],
    queryFn: async (): Promise<StandardResponse<PromptData>> => {
      const response = await PromptService.getPrompts({
        filters: {
          page: 1,
        },
      });
      return response as StandardResponse<PromptData>;
    },
    enabled: options?.enabled ?? true,
  });
};

export default useGetPrompts;
